import React from 'react';

type OverflowDirection = 'horizontal' | 'vertical' | 'both';

const useIsOverflowing = (
	containerRef: React.RefObject<HTMLDivElement>,
	contentRef: React.RefObject<HTMLDivElement>,
	direction: OverflowDirection = 'both',
	shouldRecheck: boolean = false
) => {
	const [isOverflowing, setIsOverflowing] = React.useState({
		horizontal: false,
		vertical: false
	});
	const [overflow, setOverflow] = React.useState({
		width: 0,
		height: 0
	});

	React.useEffect(() => {
		const checkOverflow = () => {
			if (containerRef.current && contentRef.current) {
				let isHorizontalOverflow = false;
				let isVerticalOverflow = false;
				let widthOverflow = 0;
				let heightOverflow = 0;

				if (direction === 'horizontal' || direction === 'both') {
					const containerWidth = containerRef.current.offsetWidth;
					const contentWidth = contentRef.current.scrollWidth;
					isHorizontalOverflow = contentWidth > containerWidth;
					widthOverflow = contentWidth - containerWidth;
				}

				if (direction === 'vertical' || direction === 'both') {
					const containerHeight = containerRef.current.offsetHeight;
					const contentHeight = contentRef.current.scrollHeight;
					isVerticalOverflow = contentHeight > containerHeight;
					heightOverflow = contentHeight - containerHeight;
				}

				setIsOverflowing({
					horizontal: isHorizontalOverflow,
					vertical: isVerticalOverflow
				});

				setOverflow({
					width: widthOverflow,
					height: heightOverflow
				});
			}
		};

		checkOverflow();
		window.addEventListener('resize', checkOverflow);

		return () => {
			window.removeEventListener('resize', checkOverflow);
		};
	}, [containerRef, contentRef, direction, shouldRecheck]);

	return { isOverflowing, overflow };
};

export default useIsOverflowing;
